<template lang="pug">
    .color-slide(:class="{active: active}")
        .color-item(v-for="(color, index) in data.colors",
          :key="index",
          :style="data.colors.length == 2 ? getStyleSided(color, index === 0 ? 'left' : 'right') : getStyle(color)",
          @click="onClick",
          ga-category="slider",
          ga-label="ч")
</template>
<script>
export default {
  name: 'ColorSlide',
  props: ['data', 'active'],
  data () {
    return {}
  },

  mounted() {
  },

  methods: {
    getStyle(color) {
      return {
        // position: 'absolute',
        // top: '0px',
        // left: '0px',
        border: this.active ? '2px solid #000' : '2px solid #DFE4E8',
        backgroundColor: color,
        borderRadius: '100%',
        width: this.data.colors.length > 1 ? '16px' : '36px',
        height: '36px'
      }
    },

    getStyleSided(color, side) {
      return side === 'left' ? {
        borderLeft: this.active ? '2px solid #000' : '2px solid #DFE4E8',
        borderTop: this.active ? '2px solid #000' : '2px solid #DFE4E8',
        borderBottom: this.active ? '2px solid #000' : '2px solid #DFE4E8',
        backgroundColor: color,
        borderTopLeftRadius: '40px',
        borderBottomLeftRadius: '40px',
        width: '18px',
        height: '36px'
      } : {
        borderRight: this.active ? '2px solid #000' : '2px solid #DFE4E8',
        borderTop: this.active ? '2px solid #000' : '2px solid #DFE4E8',
        borderBottom: this.active ? '2px solid #000' : '2px solid #DFE4E8',
        backgroundColor: color,
        borderTopRightRadius: '40px',
        borderBottomRightRadius: '40px',
        width: '18px',
        height: '36px'
      }
    },

    onClick() {
      this.$emit('click', this.data)
    }
  }
}
</script>